import { render, staticRenderFns } from "./exportSetting.vue?vue&type=template&id=2aa48456&"
import script from "./exportSetting.vue?vue&type=script&lang=js&"
export * from "./exportSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/exportSetting.vue"
export default component.exports